<template>
  <div class="footerBg">
    <div class="footer">
      <div class="center">
        山西青峰软件股份有限公司技术支持
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="less" scoped>
.footerBg {
  width: 100%;
  background-size: cover;
  .footer {
    text-align: center;
    padding: 20px 0;
    .center {
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
